import Flickity from "flickity";
import { 
  unreverse, 
  decode,
  fetchAllFrames,
  fetchItemsInFrame,
  fetchAndDisplayImage,
  getTextFromFrame,
  sortItemsByPrefix,
  miroLoader
} from "./miro-helpers.js";


export function initMiroContent() {
  const loaderApi = miroLoader();
  const canvas = document.getElementById('container');
  const token = unreverse(window._ms.t);
  const boardId = unreverse(window._ms.b);


// --- Declare frames, captionsMap, and fgColorsMap in outer scope ---
let frames = [];
let captionsMap = {};
let fgColorsMap = {};
let slideLinksMap = {};

  //set loading progress
  loaderApi.setProgress(5);


// captions

  // Create caption container in JS if not present
let captionEl = document.getElementById('miro-caption');
if (!captionEl) {
  captionEl = document.createElement('div');
  captionEl.id = 'miro-caption';
  captionEl.className = 'miro-caption grid';

  // Create the inner grid__content-item div
  const captionContent = document.createElement('div');
  captionContent.className = 'caption grid__content-item --justify-right --start-col4--1 --end-col4--4 --start-col6--2 --end-col6--5 --start-col8--1 --end-col8--4 --start-col10--1 --end-col10--5 --start-col12--1 --end-col12--4';
  captionEl.appendChild(captionContent);

  // Insert after the Flickity slider (canvas)
  if (canvas && canvas.parentNode) {
    canvas.parentNode.insertBefore(captionEl, canvas.nextSibling);
  } else {
    document.body.appendChild(captionEl);
  }
}
  //end captions

if (!token || !boardId) {
  console.error('Missing Miro token or boardId!');
  return;
}

// console.log('Decoded token:', token);
// console.log('Decoded boardId:', boardId);


   // Flickity initialization function
  function initFlickity() {
  setTimeout(() => {
    if (canvas && canvas.children.length > 0) {
      const flkty = new Flickity(canvas, {
        wrapAround:true,
        pageDots: true,
        cellAlign: 'left',
        contain: true,
        adaptiveHeight: true,
        prevNextButtons: true,
        draggable: true,
        dragThreshold: 10,
        touchVerticalScroll: true,
        selectedAttraction: 0.02,
        friction: 0.28
      });

      let isDragging = false;
      let isScrolling = false;

      // When Flickity drag starts, block page scroll
      flkty.on('dragStart', () => {
        isDragging = true;
        canvas.style.touchAction = 'none'; // disables vertical scroll
        document.body.style.overflow = 'hidden'; // disables page scroll
      });

      // When Flickity drag ends, allow page scroll again
      flkty.on('dragEnd', () => {
        isDragging = false;
        canvas.style.touchAction = '';
        document.body.style.overflow = '';
      });

      // When user scrolls the page, block Flickity drag
      window.addEventListener('scroll', () => {
        if (!isScrolling) {
          isScrolling = true;
          flkty.options.draggable = false;
          flkty.updateDraggable();
        }
        clearTimeout(window._scrollTimeout);
        window._scrollTimeout = setTimeout(() => {
          isScrolling = false;
          flkty.options.draggable = true;
          flkty.updateDraggable();
        }, 250);
      });

      canvas.classList.add('flickity-ready');
      document.body.classList.add('flickity-ready');

      // Update caption and fg color on slide change
      function updateCaptionAndFg(index) {
        const frame = frames[index];
        const caption = captionsMap[frame.data?.title] || '';
        const fgColor = fgColorsMap[frame.data?.title];
        const slideLink = slideLinksMap[frame.data?.title] || '';
        const extractedBgColor = frame.style?.fillColor;

        // console.log('HEREH Setting site background color to:', extractedBgColor);
        // console.log('Frame title:', frame.data?.title);
        // console.log('Frame style:', frame.style);
        // console.log('Frame data:', frame.data);
        // console.log('Captions map:', captionsMap);
        // console.log('Foreground colors map:', fgColorsMap);
        // console.log('Slide links map:', slideLinksMap);
        // console.log('slideLink',  slideLink);

        // Caption
        const captionContent = captionEl.querySelector('.grid__content-item');
        if (captionContent) {
          let html = caption;
console.log("caption",caption);

if (slideLink && typeof slideLink === 'string' && slideLink.trim() !== '') {
            html += `<a href="${slideLink}" class="slide-link" target="_blank" rel="noopener">More</a>`;
          }
          captionContent.innerHTML = html;
        }

        // Foreground color
        if (fgColor) {
          document.body.style.setProperty('--site-fg', fgColor);
          // console.log('Set site foreground color to:', fgColor);
        }
          // Foreground color
        if (extractedBgColor) {
          document.body.style.setProperty('--site-bg', extractedBgColor);
          // console.log('Set site foreground color to:', extractedBgColor);
        }
        

      }
      updateCaptionAndFg(flkty.selectedIndex);

      flkty.on('change', index => {
        updateCaptionAndFg(index);
      });

      flkty.on('dragStart', () => {
        canvas.style.touchAction = 'pan-y';
      });
      flkty.on('dragEnd', () => {
        canvas.style.touchAction = '';
      });
    }
  }, 100);
}

  // Load frames and their items, then init Flickity ONCE
  async function loadFramesAndContents(boardId, token) {
    try {
      const allFrames = await fetchAllFrames(boardId, token);
      loaderApi.setProgress(30);

      // --- Set site background color ---
      const bgFrame = allFrames.find(f => (f.data?.title || '').toLowerCase() === 'web_bg_color');
      if (bgFrame && bgFrame.style?.fillColor) {

        // console.log('Setting site background color to:', bgFrame.style.fillColor);

        document.body.style.setProperty('--site-bg', bgFrame.style.fillColor);
      }

      // --- Set site foreground color (default/global) ---
      const fgFrame = allFrames.find(f => (f.data?.title || '').toLowerCase() === 'web_fg_color');
      if (fgFrame && fgFrame.style?.fillColor) {
        document.body.style.setProperty('--site-fg', fgFrame.style.fillColor);
      }

      // --- Inject intro text ---
      const introText = await getTextFromFrame(
        allFrames,
        'web_copy_intro',
        frameId => fetchItemsInFrame(boardId, token, frameId)
      );
      // console.log('[loadFramesAndContents] introText:', introText);
      const introEl = document.getElementById('intro-copy');
      // console.log('[loadFramesAndContents] introEl:', introEl);
      if (introEl && introText) introEl.innerHTML = introText; // Use innerHTML for HTML content

      // --- Render module frames (and update captions and fg colors) ---
      frames = allFrames.filter(f => (f.data?.title || '').toLowerCase().includes('module_'));
      const frameCaption = allFrames.filter(f => (f.data?.title || '').toLowerCase().includes('caption_'));
      const frameFgColors = allFrames.filter(f => (f.data?.title || '').toLowerCase().includes('fg_color_'));
      const frameLinks = allFrames.filter(f => (f.data?.title || '').toLowerCase().includes('slide_link_'));

// console.log('Module frames:', frames);
// console.log('Caption frames:', frameCaption);
// console.log('FG color frames:', frameFgColors);
// console.log('Slide link frames:', frameLinks.map(f => f.data?.title));

      // Build captions map
      captionsMap = {};
      for (const frame of frames) {
        const captionFrame = frameCaption.find(fc => fc.data?.title === frame.data?.title.replace('module_', 'caption_'));
        if (captionFrame) {
          const captionText = await getTextFromFrame(
            allFrames,
            captionFrame.data?.title || '',
            frameId => fetchItemsInFrame(boardId, token, frameId)
          );
          captionsMap[frame.data?.title] = captionText;

          console.log('Caption for', frame.data?.title, ':', captionText);
        }
      }

      // Build fgColors map
      fgColorsMap = {};
      for (const frame of frames) {
        const fgColorFrame = frameFgColors.find(fc => fc.data?.title === frame.data?.title.replace('web_module_', 'fg_color_'));
        if (fgColorFrame && fgColorFrame.style?.fillColor) {
          fgColorsMap[frame.data?.title] = fgColorFrame.style.fillColor;
        }

        // console.log('FG color for', frame.data?.title, ':', fgColorsMap[frame.data?.title]);
      }

     // Build slide links map
   slideLinksMap = {};
    for (const frame of frames) {
      const linkKey = frame.data?.title.replace('module_', 'slide_link_');
      const linkFrame = frameLinks.find(fc => fc.data?.title === linkKey);

      // console.log('Processing frame:', frame.data?.title);
      // console.log("frame",frame.data?.text);
      // console.log('Looking for link frame with title:', linkKey, 'Found:', !!linkFrame);

      if (linkFrame) {
        // Use getTextFromFrame just like for captions
        const linkText = await getTextFromFrame(
          allFrames,
          linkFrame.data?.title || '',
          frameId => fetchItemsInFrame(boardId, token, frameId)
        );
      if (linkText) {
      // Strip HTML tags
      const plainLink = linkText.replace(/<[^>]*>/g, '').trim();
      slideLinksMap[frame.data?.title] = plainLink;
        }
          }
      // console.log('Slide link for', frame.data?.title, ':', slideLinksMap[frame.data?.title]);
  }

      loaderApi.setProgress(60);


      // Clear existing content
      canvas.innerHTML = '';

      for (const frame of frames) {
        // Log the entire frame object to inspect its structure
        // console.log('Frame object:', frame);
        // console.log('Frame style:', frame.style);
        // console.log('Frame data:', frame.data);

        const frameWidth = frame.geometry?.width || 300;
        const frameHeight = frame.geometry?.height || 300;
        const frameDiv = document.createElement('div');
        frameDiv.className = 'frame-responsive';
        frameDiv.style.aspectRatio = `${frameWidth} / ${frameHeight}`;

        // Set frame background color from API
        if (frame.style?.fillColor) {
          frameDiv.style.backgroundColor = frame.style.fillColor;
        }

        const items = await fetchItemsInFrame(boardId, token, frame.id);
        // Sort by numeric prefix in title (or data) -- review this bit iof code here
        items.sort((a, b) => {
          const getPrefix = item => {
            const title = item.data?.title || item.title || '';
            const match = title.match(/^(\d+)_/);
            return match ? parseInt(match[1], 10) : 9999;
          };
          return getPrefix(a) - getPrefix(b);
        });
        //end review ths bit of code here

        const imagePromises = [];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const el = document.createElement('div');
          el.className = 'item-abs';

          el.style.zIndex = i + 1;
          el.setAttribute('data-id', item.id || '');
          el.setAttribute('data-type', item.type || '');
          el.setAttribute('data-zindex', i + 1);
          el.setAttribute('data-name', item.data?.title || item.title || '');

          const itemWidth = (item.geometry?.width || 0);
          const itemHeight = (item.geometry?.height || 0);
          const itemCenterX = item.position?.x || 0;
          const itemCenterY = item.position?.y || 0;
          const itemTopLeftX = (itemCenterX - (item.geometry?.width || 0) / 2);
          const itemTopLeftY = (itemCenterY - (item.geometry?.height || 0) / 2);

          el.style.left = ((itemTopLeftX / frameWidth) * 100) + '%';
          el.style.top = ((itemTopLeftY / frameHeight) * 100) + '%';
          el.style.width = ((itemWidth / frameWidth) * 100) + '%';
          el.style.height = ((itemHeight / frameHeight) * 100) + '%';

          switch (item.type) {
            case 'text':
              el.textContent = item.data?.text || '';
              el.style.fontSize = '1.2vw';
              el.style.color = item.style?.fontColor || '#000';
              el.style.fontWeight = item.style?.bold ? 'bold' : 'normal';
              el.style.background = '#fff8';
              el.style.display = 'flex';
              el.style.alignItems = 'center';
              el.style.justifyContent = 'center';
              frameDiv.appendChild(el);
              break;

            case 'sticker':
              el.textContent = item.data?.content || '';
              el.style.backgroundColor = 'yellow';
              el.style.border = '1px solid #000';
              el.style.padding = '0.5vw';
              el.style.borderRadius = '0.5vw';
              el.style.display = 'flex';
              el.style.alignItems = 'center';
              el.style.justifyContent = 'center';
              frameDiv.appendChild(el);
              break;

            case 'image':
              const imagePromise = fetchAndDisplayImage(item, token).then(img => {
                if (img) {
                  el.appendChild(img);
                  frameDiv.appendChild(el);
                }
              });
              imagePromises.push(imagePromise);
              break;

            case 'shape':
              el.style.backgroundColor = item.style?.backgroundColor || '#ccc';
              el.style.borderRadius = item.style?.shapeType === 'ellipse' ? '50%' : '0';
              frameDiv.appendChild(el);
              break;

            default:
              el.textContent = `[${item.type}]`;
              el.style.background = '#eee';
              el.style.display = 'flex';
              el.style.alignItems = 'center';
              el.style.justifyContent = 'center';
              frameDiv.appendChild(el);
          }
        }

        await Promise.all(imagePromises);

        if (frameDiv.children.length > 0) {
          canvas.appendChild(frameDiv);
        }
      }

      // Remove any empty children from the container
      [...canvas.children].forEach(child => {
        if (!child.hasChildNodes()) {
          canvas.removeChild(child);
        }
      });

      // Only init Flickity after ALL content is loaded
      initFlickity();
      loaderApi.setProgress(100);
      loaderApi.hideLoader(); // hide once finished
    } catch (err) {
      loaderApi.hideLoader();
      console.error('❌ Load error:', err);
      canvas.innerHTML = 'Failed to load frames and content.';
    }
  }


  // Only load ONCE
  loadFramesAndContents(boardId, token);
}